import { render } from "./Text.vue?vue&type=template&id=3149b24a"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import exportComponent from "/home/berisalam-console/webapps/berisalam-console/releases/1793606032384/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__